import { render, staticRenderFns } from "./AmetrasCustomPaginationTemplate.vue?vue&type=template&id=4c756124&scoped=true&"
import script from "./AmetrasCustomPaginationTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasCustomPaginationTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasCustomPaginationTemplate.vue?vue&type=style&index=0&id=4c756124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c756124",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
